import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { KeyRound, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { jmd } from "@/lib/format";

/* Doors page: real door hardware already in the catalogue (Yale locks etc.) while door slabs await a supplier list. */
export function DoorHardwareStrip() {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  useEffect(() => {
    api.get("/products", { params: { q: "yale", limit: 24 } }).then(({ data }) => { const items = (data.items || data || []).filter((p) => p.price); const locks = items.filter((p) => /lock|deadbolt|bolt|latch/i.test(p.name) && !/kit|card|hub|module|battery/i.test(p.name)); const rest = items.filter((p) => !locks.includes(p)); setRows([...locks, ...rest].slice(0, 8)); setTotal(items.length); }).catch(() => {});
  }, []);
  if (!rows.length) return null;
  return (
    <section className="bg-white rounded-2xl border border-black/5 p-4 mb-4" data-testid="door-hardware-strip">
      <div className="flex flex-wrap items-center gap-2 mb-3">
        <KeyRound size={16} className="text-emerald" /><h3 className="font-display font-extrabold">Door hardware in stock now</h3>
        <span className="text-xs text-muted-foreground">Yale locks, deadbolts, rim locks &amp; digital locks — priced, GCT-inclusive, ready to add to cart</span>
        <Link to="/search?q=yale" className="ml-auto text-xs font-bold text-emerald inline-flex items-center gap-1" data-testid="door-hardware-all">See all Yale <ArrowRight size={12} /></Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2">
        {rows.map((p) => (
          <Link key={p.id} to={`/product/${p.id}`} className="group rounded-xl border border-border p-2 hover:shadow-md transition-shadow" data-testid={`door-hw-${p.id}`}>
            <img src={p.image} alt={p.name} className="w-full aspect-square object-contain rounded-lg bg-[#f6f5f1]" loading="lazy" />
            <div className="text-[11px] font-semibold mt-1 line-clamp-2 leading-tight">{p.name}</div>
            <div className="text-[11px] text-ink font-bold">{p.price ? jmd(p.price) : "Quote"}</div>
          </Link>
        ))}
      </div>
      <p className="text-[11px] text-muted-foreground mt-3">Door slabs, frames and patio/garage doors are quote-first until a door supplier's price list is loaded — use "Request a quote" on any item above-left.</p>
    </section>
  );
}
